/**
 * Guard for live subscription pushes: the WS socket authenticates once per connection, so right
 * after an org switch a push can still arrive under the PREVIOUS tenant's JWT (RTLCA-5588). Drop
 * any pushed project whose tenantId doesn't match the session's current tenant instead of
 * upserting it into the list.
 */
export default function isProjectFromCurrentTenant(
  project: { tenantId?: string | null },
  currentTenantId: string | null | undefined
): boolean {
  return !!currentTenantId && project.tenantId === currentTenantId;
}
